export class TeachrRCS {
  readonly "@id"?: string;
  readonly "@type"?: string;
  readonly "@context"?: string;

  RCS: string;

  readonly id?: number;
  readonly lastModificationDatetime?: Date;
  readonly creationDatetime?: Date;

  constructor(RCS: string) {
    this.RCS = RCS;
  }
}

export class ProfileTeachr {
  // readonly "@id"?: string;
  // readonly "@type"?: string;
  // readonly "@context"?: string;

  siret: string;
  RCS?: string;
  description: string;
  address: number;
  iban: string;
  businessType: string;
  bic: string;
  tauxTva: string;
  tvaNumber : string
  subjectToTeach?: []
  profilePicture?: number

  // readonly id?: number;
  // readonly lastModificationDatetime?: Date;
  // readonly creationDatetime?: Date;

  constructor(
    siret: string,
    description: string,
    address: number,
    iban: string,
    businessType: string,
    bic: string,
    tauxTva: string,
    tvaNumber: string,
    
  ) {
    this.siret = siret;
    this.description = description;
    this.address = address;
    this.iban = iban;
    this.businessType = businessType;
    this.bic = bic;
    this.tauxTva = tauxTva;
    this.tvaNumber = tvaNumber;
  }
}
